import { render, staticRenderFns } from "./DynamicFieldsRenderer.vue?vue&type=template&id=dc90fe02&scoped=true"
import script from "./DynamicFieldsRenderer.vue?vue&type=script&lang=js"
export * from "./DynamicFieldsRenderer.vue?vue&type=script&lang=js"
import style0 from "./DynamicFieldsRenderer.vue?vue&type=style&index=0&id=dc90fe02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc90fe02",
  null
  
)

export default component.exports